import * as React from 'react';

import {Link} from 'shells/link/link';
import {Body} from 'shells/typography/body';

import styles from '../calendar.module.css';

type Props = {
    lockdownEmail: string | null | undefined;
};

export function ReadOnlyBanner(props: Props) {
    const calendar = props.lockdownEmail || 'the associated calendar';

    return (
        <div className='flex justify-sb full-width align-center'>
            <div className={styles['read-only-text']}>
                <Body>
                    This activity is connected to an external calendar and cannot be edited.
                    Reconnect Nutshell to{' '}
                </Body>
                <Body isBold={Boolean(props.lockdownEmail)}>{calendar}</Body>
                <Body> or allow guests to modify the event.</Body>
            </div>
            <Link
                href='https://support.nutshell.com/en/articles/8428898-how-to-sync-google-calendar-with-nutshell'
                // @ts-expect-error
                target='_blank'
                variant='primary'
            >
                Learn more
            </Link>
        </div>
    );
}
